import { Link } from 'react-router-dom';
import { LogoExamsReactor } from '@examsreactor/ui';

export function Footer() {
  return (
    <footer className="border-t border-border-subtle bg-bg-secondary">
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <LogoExamsReactor variant="full" size="md" />
            <p className="mt-3 text-xs text-text-tertiary">
              Simulador independiente de certificaciones cloud para profesionales TI de LATAM y Espana.
            </p>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-wide text-text-tertiary">Producto</h3>
            <ul className="mt-3 space-y-2 text-sm">
              <li>
                <Link to="/certificaciones" className="text-text-secondary hover:text-text-primary">
                  Certificaciones
                </Link>
              </li>
              <li>
                <Link to="/precios" className="text-text-secondary hover:text-text-primary">
                  Precios
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-wide text-text-tertiary">Legal</h3>
            <ul className="mt-3 space-y-2 text-sm">
              <li>
                <Link to="/privacidad" className="text-text-secondary hover:text-text-primary">
                  Privacidad
                </Link>
              </li>
              <li>
                <Link to="/terminos" className="text-text-secondary hover:text-text-primary">
                  Terminos
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="text-text-secondary hover:text-text-primary">
                  Cookies
                </Link>
              </li>
              <li>
                <Link to="/reembolso" className="text-text-secondary hover:text-text-primary">
                  Reembolso 48h
                </Link>
              </li>
              <li>
                <Link to="/libro-de-reclamaciones" className="text-text-secondary hover:text-text-primary">
                  Libro de Reclamaciones
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-wide text-text-tertiary">Soporte</h3>
            <ul className="mt-3 space-y-2 text-sm">
              <li>
                <a
                  href="mailto:paul.marquina@outlook.com"
                  className="text-text-secondary hover:text-text-primary"
                >
                  Contacto
                </a>
              </li>
              <li>
                <Link to="/faq" className="text-text-secondary hover:text-text-primary">
                  Preguntas frecuentes
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-border-subtle pt-6">
          <p className="text-xs text-text-tertiary">
            ExamsReactor es un simulador independiente. NO esta afiliado oficialmente con Microsoft,
            Amazon Web Services ni ningun otro vendor. Los nombres de examenes y certificaciones son
            marcas registradas de sus respectivos propietarios.
          </p>
          <p className="mt-2 text-xs text-text-tertiary">
            (c) 2026 ExamsReactor. Operado por Paul Marquina (Persona Natural con Negocio) / SAC en
            formacion.
          </p>
        </div>
      </div>
    </footer>
  );
}
